// src/pages/MahilaBal.js
import React from "react";

export default function MahilaBal() {
  const styles = {
    container: {
      padding: "20px",
      maxWidth: "900px",
      margin: "0 auto",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.6",
      color: "#333",
    },
    heading: {
      textAlign: "center",
      marginBottom: "20px",
      color: "#2c3e50",
    },
    section: {
      marginBottom: "20px",
    },
    list: {
      paddingLeft: "20px",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>महिला व बाल विकास विभाग</h1>

      <div style={styles.section}>
        <h2>विभागाची प्रस्तावना</h2>
        <p>
          एकात्मिक बाल विकास सेवा योजना ही केंद्र शासन पुरस्कृत योजना आहे. 
          ही २ ऑक्टोबर १९७५ रोजी राष्ट्रपिता महात्मा गांधींच्या १०६ व्या जयंती दिनी सुरू करण्यात आली.
        </p>
      </div>

      <div style={styles.section}>
        <h2>रचना</h2>
        <p>
          छत्रपती संभाजीनगर जिल्ह्यामध्ये एकात्मिक बाल विकास सेवा योजनेंतर्गत ग्रामीण भागात एकूण १४ प्रकल्प कार्यरत आहेत. 
          या १४ प्रकल्पांतील ३४२३ अंगणवाड्या जिल्ह्यात कार्यरत आहेत.
        </p>
      </div>

      <div style={styles.section}>
        <h2>अंगणवाडीतील सेवा</h2>
        <p>अंगणवाडीत ० ते ६ वर्षे वयोगटातील बालके, गरोदर व स्तनदा माता, किशोरवयीन मुली यांना खालील सेवा पुरविण्यात येतात:</p>
        <ul style={styles.list}>
          <li>पुरक पोषण आहार</li>
          <li>आरोग्य व पोषण शिक्षण</li>
          <li>पूर्व प्राथमिक शिक्षण</li>
          <li>लसीकरण</li>
          <li>संदर्भ सेवा</li>
          <li>आरोग्य तपासणी</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>योजनेचे उद्दिष्ट</h2>
        <ul style={styles.list}>
          <li>1 ते ६ वर्षे वयोगटातील मुलांचा पोषण व आरोग्य दर्जा सुधारणे.</li>
          <li>मुलांच्या योग्य मानसिक, शारीरिक व सामाजिक विकासाचा पाया घालणे.</li>
          <li>गरजू बालकांच्या व कुपोषितांच्या प्रमाणात कमी करणे.</li>
          <li>बाल विकास कार्यक्रमातील विविध विभागांमधील धोरण व अंमलबजावणी याबाबत परिणामकारक समन्वय साधणे.</li>
          <li>बाल विकास सेवा योजनेंतर्गत सर्वसामान्य आरोग्य व त्यांच्या पोषण विषयक गरजांकडे लक्ष पुरविण्याबाबत मातांची क्षमता वाढवणे.</li>
        </ul>
      </div>

      <div style={styles.section}>
        <h2>संपर्क</h2>
        <p>संपर्क तपशील विभागानुसार येथे जोडले जातील.</p>
      </div>
    </div>
  );
}
